var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "Area-Select" },
    [
      _c("div", { staticClass: "top", staticStyle: { display: "flex" } }, [
        _c("h1", [_vm._v("请选择接单区域")]),
        _c(
          "a",
          {
            on: {
              click: function ($event) {
                return _vm.selectArea()
              },
            },
          },
          [_vm._v("点击选择区域")]
        ),
      ]),
      _c(
        "div",
        { staticClass: "showArea" },
        _vm._l(_vm.tags, function (tag) {
          return _c(
            "el-tag",
            {
              key: tag.nameCn,
              attrs: { closable: "", type: "info" },
              on: {
                close: function ($event) {
                  return _vm.handleClose(tag)
                },
              },
            },
            [_vm._v(" " + _vm._s(tag.nameCn) + " ")]
          )
        }),
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "productTypeDialog",
          attrs: {
            title: "提示",
            "close-on-click-modal": false,
            "custom-class": "customProduct",
            visible: _vm.placeTypeShow,
            width: "25%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.placeTypeShow = $event
            },
          },
        },
        [
          _c("div", { staticClass: "dialog-top" }, [
            _c("span", [_vm._v("接单区域选择")]),
          ]),
          _c(
            "div",
            {
              staticClass: "product-checkBox",
              staticStyle: {
                "padding-right": "10px",
                display: "flex",
                "flex-direction": "column",
                "justify-content": "center",
              },
            },
            [
              _c(
                "el-radio-group",
                {
                  staticStyle: { "margin-bottom": "15px" },
                  model: {
                    value: _vm.placeType,
                    callback: function ($$v) {
                      _vm.placeType = $$v
                    },
                    expression: "placeType",
                  },
                },
                [
                  _c("el-radio", { attrs: { label: 0 } }, [_vm._v("国家")]),
                  _c("el-radio", { attrs: { label: 1 } }, [_vm._v("城市")]),
                  _c("el-radio", { attrs: { label: 2 } }, [_vm._v("区域")]),
                  _c("el-radio", { attrs: { label: 3 } }, [_vm._v("省份")]),
                ],
                1
              ),
              _c(
                "el-select",
                {
                  staticStyle: { width: "97%" },
                  attrs: {
                    multiple: "",
                    filterable: "",
                    remote: "",
                    "reserve-keyword": "",
                    "collapse-tags": "",
                    placeholder: "请输入关键词",
                    "remote-method": _vm.remotePlaceMethod,
                  },
                  on: {
                    focus: function ($event) {
                      return _vm.remotePlaceMethod("")
                    },
                  },
                  model: {
                    value: _vm.checkPlace,
                    callback: function ($$v) {
                      _vm.checkPlace = $$v
                    },
                    expression: "checkPlace",
                  },
                },
                _vm._l(_vm.placeOptions, function (item) {
                  return _c("el-option", {
                    key: item.pid,
                    attrs: { label: item.nameCn, value: JSON.stringify(item) },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.placeTypeShow = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.handleSelectPlace()
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }